// extracted by mini-css-extract-plugin
module.exports = {"backgroundColor":"#f2f2f5","modal":"styles_modal__l3ymL"};